import React, { useContext, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { showTopbarInsideAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import HeaderDefaultToPage from "../../components/Common/headerDefaultToPage";
import { Link } from "react-router-dom";
import {
  MEUS_DADOS,
  MS_ALTERAR_EMAIL,
  MS_REDEFINIR_SENHA,
  PERFIS_DE_ACESSO,
  PERMISSOES_USUARIO,
} from "../../helpers/routes_helper";
import { CardGridCustom } from "../../components/Common/CardGridCustom";
import { AuthProtectedContext } from '../../Routes/AuthProtectedContext'
import { Skeleton } from "primereact/skeleton";
import { fnGetValueByKey } from "../../helpers/functions";

const BI_WS0002 = () => {
  document.title = "Defender | Configurações do Perfil";

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const { transactionData } = useContext(AuthProtectedContext);

  const { isIframePage } = useSelector(state => ({
    isIframePage: state.Layout.isIframePage
  }));

  const [usuario, setUsuario] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  // const [acessos, setAcessos] = useState([]);
  // const [permissoes, setPermissoes] = useState([]);
  const [error, setError] = useState(false);

  const rawCel = usuario?.Telefone_Celular ?? "";
  const celTrim = rawCel.replace("(", " (").replace(")", ") ");
  const digits = celTrim.replace(/\D/g, "");
  const showCelular = digits.length >= 8;

  useEffect(() => {
    dispatch(showTopbarInsideAction({}));
  }, []);

  useEffect(() => {
    let data = fnGetValueByKey(transactionData, "PROCEDURE_RESULTSET")
    try {
      data = JSON.parse(data)
      setUsuario(data && data[0]?.Conteudo && JSON?.parse(data[0]?.Conteudo)[0] || []);
      setEmpresas(data && data[1]?.Conteudo && JSON?.parse(data[1]?.Conteudo) || []);
    } catch (error) {
      console.warn("Erro ao parsear PROCEDURE_RESULTSET:", error);
    }
  }, [transactionData]);

  return (
    <React.Fragment>
      <div className={`page-content page-config ${isIframePage && 'is-iframe-content'}`}>
        <Container fluid={true} className="dataTable-custom-primary">
          {loading ? (
                <Skeleton width={400} height={50} />
              ) : 
            <HeaderDefaultToPage
              goBack={false}
              title={fnGetValueByKey(transactionData, "TITULO_TRANSACAO")}
            />
              }

            <div style={{gap: 16}} className="d-flex my-2 content-page">
              {loading || !usuario?.Nome_Completo ? (
                <Skeleton className="w-100" height={400} />
              ) : (
                <div className="w-100">
                    <CardGridCustom title="Meus Dados" className="skeleton-div">
                      <div className="skeleton-div">
                        <div style={{gap: 8}} className="col-12 pb-3 d-flex align-items-center border-bottom">
                          {usuario?.Foto_Usuario ? <img src={usuario?.Foto_Usuario} className="img-user" /> : <i
                                    className="far fa-user-circle user-photo-label"
                                    aria-hidden="true"
                                    style={{ fontSize: 48, lineHeight: 1 }}
                                  />}
                          <div className="d-flex w-100 justify-content-between flex-wrap">
                            <div className="d-flex flex-column">
                              <span className="username">
                                {usuario?.Nome_Completo}
                              </span>
                              <span className="business-description">
                                {usuario?.Cargo}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="py-3 d-flex flex-column gap-2 border-bottom">
                          <span className="label-user">CPF</span>
                          <span className="value-user">{usuario?.CPF}</span>
                        </div>
                        <div className="py-3 d-flex flex-column gap-2 border-bottom">
                          <span className="label-user">E-mail</span>
                          <span
                            className="value-user" //email-truncate
                            title={usuario?.Email}
                          >
                            {usuario?.Email}
                          </span>
                        </div>
                        {showCelular && (
                          <div className="py-3 d-flex flex-column gap-2 border-bottom">
                            <span className="label-user">Celular</span>
                            <span className="value-user">
                              {celTrim}
                            </span>
                          </div>
                        )}
                      </div>
                      <Link to={MEUS_DADOS} className="btn-link-page">
                        Editar meus dados
                      </Link>
                    </CardGridCustom>
                </div>
              )}

              {loading || !usuario?.Nome_Completo ? (
                <Skeleton className="w-100" height={350} />
              ) : (
                <div className="w-100">
                  <CardGridCustom
                    title="Minha Segurança"
                    className="skeleton-div"
                  >
                    <ul className="ul-list-custom">
                      <li className="border-bottom">
                        <Link
                          to={MS_REDEFINIR_SENHA}
                          className="d-flex align-items-center justify-content-between"
                        >
                          <span>Redefinir Senha</span>
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                      </li>
                      <li className="border-bottom">
                        <Link
                          to={MS_ALTERAR_EMAIL}
                          href=""
                          className="d-flex align-items-center justify-content-between "
                        >
                          <span>Alterar Login</span>
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                      </li>
                      <li className="border-bottom">
                        <Link
                          to={PERFIS_DE_ACESSO}
                          href=""
                          className="d-flex align-items-center justify-content-between "
                        >
                          <span>Meus Perfis de Acesso</span>
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                      </li>
                      <li className="border-bottom">
                        <Link
                          to={PERMISSOES_USUARIO}
                          href=""
                          className="d-flex align-items-center justify-content-between "
                        >
                          <span>Minhas Permissões</span>
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          to={"/BI_WS0007"}
                          href=""
                          className="d-flex align-items-center justify-content-between "
                        >
                          <span>Dispositivos de Acesso</span>
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                      </li> */}
                    </ul>
                  </CardGridCustom>
                </div>
              )}

              {loading || empresas.length === 0 ? (
                <Skeleton className="w-100" height={400} />
              ) : (
                <div className="w-100">
                  <CardGridCustom
                    title="Minhas Empresas"
                    notifyNumber={empresas.length}
                    className="skeleton-div"
                  >
                    <ul className="ul-list-empresa p-0 m-0">
                      {empresas.length === 0 ? (
                        <li className="border-bottom">
                          <span className="text-muted">
                            Nenhuma empresa encontrada
                          </span>
                        </li>
                      ) : (
                        empresas.slice(0, 6).map((emp) => (
                          <li
                            key={emp.ID_Empresa}
                            className="border-bottom"
                          >
                            <div style={{gap: 8}} className="d-flex align-items-center">
                              {emp.Logo_Empresa ? (
                                <img
                                  src={emp.Logo_Empresa}
                                  alt={emp.Nome_Fantasia}
                                  className="img-user"
                                />
                              ) : (
                                <i
                                  className="far fa-user-circle user-photo-label me-2"
                                  aria-hidden="true"
                                  style={{ fontSize: 48, lineHeight: 1 }}
                                />
                              )}
                              <div className="d-flex flex-column">
                                <span className="business-name">
                                  {emp.Nome_Fantasia}
                                </span>
                                <small className="text-muted">
                                  {emp.Nome_Empresa}
                                </small>
                              </div>
                            </div>
                          </li>
                        ))
                      )}
                    </ul>
                    <Link to={"/BI_WS0007"} className="btn-link-page mt-3">
                      Visualizar mais informações
                    </Link>
                  </CardGridCustom>
                </div>
              )}

              {/* {loading ? (
                <Skeleton width="340px" height={370} />
              ) : (
                <div style={{ width: 340 }}>
                  <CardGridCustom
                    title="Meus Perfis de Acesso"
                    notifyNumber={acessos.length}
                    className="skeleton-div"
                  >
                    <ul className="ul-list-custom mb-3">
                      {acessos.length === 0 ? (
                        <li className="text-muted">Nenhum perfil atribuído</li>
                      ) : (
                        acessos.map((acc, idx) => (
                          <li
                            key={acc.ID_Perfil}
                            className={`border-bottom${
                              idx === acessos.length - 1 ? '' : ''
                            }`}
                          >
                            <span>{acc.Descricao_Perfil}</span>
                          </li>
                        ))
                      )}
                    </ul>
                    <Link to={PERFIS_DE_ACESSO} className="btn-link-page">
                      Visualizar mais informações
                    </Link>
                  </CardGridCustom>
                </div>
              )} */}
            </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BI_WS0002;
